module.exports = __webpack_public_path__ + "static/media/ecopotager.e29f54e1.png";